import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import {
  IBaseProjectResumeConfig,
  IResumeProjectConfig,
} from '../models/projectResumeConfigModel';
import {
  createResumeProjectConfigEndpoint,
  getResumeProjectConfigEndpoint,
  getResumeProjectInitialConfigEndpoint,
  updateResumeProjectConfigEndpoint,
} from '../services/projectResumeConfigService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

const useAdminProjectLayoutConfig = () => {
  const { callEndpoint } = useCallApiAndLoad();
  const [apiErrors, setApiErrors] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  //
  const doRetrieveInitialConfigResume = async (
    projectId: string,
  ): Promise<IBaseProjectResumeConfig> => {
    const { data } = await callEndpoint(
      getResumeProjectInitialConfigEndpoint(projectId, token),
    );
    const response = fetchResponseAdapter(data);

    return response.data;
  };

  const doRetrieveResumeConfigByProject = async (
    projectId: string,
  ): Promise<IResumeProjectConfig | null> => {
    const { data } = await callEndpoint(
      getResumeProjectConfigEndpoint(projectId, token),
    );
    const response = fetchResponseAdapter(data);

    return response.data;
  };

  const doCreateProjectResumeConfig = async (
    projectId: string,
    payload: IBaseProjectResumeConfig,
  ): Promise<number> => {
    const { data, status } = await callEndpoint(
      createResumeProjectConfigEndpoint(projectId, payload, token),
    );
    const response = fetchResponseAdapter(data);

    if (status !== 201) setApiErrors(response.message);
    return status;
  };

  const doUpdateProjectResumeConfig = async (
    id: string,
    payload: IBaseProjectResumeConfig,
  ): Promise<number> => {
    const { data, status } = await callEndpoint(
      updateResumeProjectConfigEndpoint(id, payload, token),
    );
    const response = fetchResponseAdapter(data);

    if (status !== 200) setApiErrors(response.message);
    return status;
  };

  return {
    apiErrors,
    doCreateProjectResumeConfig,
    doRetrieveInitialConfigResume,
    doRetrieveResumeConfigByProject,
    doUpdateProjectResumeConfig,
  };
};

export default useAdminProjectLayoutConfig;
